import { Sidebar } from './sidebar';
import { InventoryDashboard } from '../inventory-management/inventory-dashboard';
import { MainPage } from './main-page';
import { Fragment, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation, useNavigate } from 'react-router-dom';
import { Modifiers } from '../modifiers-management/modifiers';
import { capitalize } from 'lodash';
import { LoginCallback, useOktaAuth } from '@okta/okta-react';
import { LoginOkta } from '../../auth/okta-login';
import { useSelector } from 'react-redux';
import { currentButton } from '../../store/sidebar.slice';
import { TokenLogin } from '../../auth/token-login';
import { RootState } from '../../store/store';
import { storeFrontAuthSelectors } from '../../store/store-front-auth';

export function MainApp() {
  const { pathname } = useLocation();
  const { authState } = useOktaAuth();
  const navigate = useNavigate();
  const currentPressedButton = useSelector(currentButton);
  const isStoreFrontLoggedIn = useSelector((state: RootState) =>
    storeFrontAuthSelectors.selectIsLoggedIn(state.storeFrontAuth)
  );

  const isAuthenticated: boolean = authState?.isAuthenticated || isStoreFrontLoggedIn;

  useEffect(() => {
    document.title = `Homesome Admin${
      pathname.length > 1 ? ' | ' + capitalize(pathname.substring(1)) : ''
    }`;
  }, [pathname]);

  // Makes sure after we log in, we are routed to the right path.
  // Happens only after we authenticate
  useEffect(() => {
    if (isAuthenticated) {
      navigate(currentPressedButton as string, { replace: true });
    }
    // eslint-disable-next-line
  }, [isAuthenticated]);

  if (isAuthenticated || window.Cypress) {
    return (
      <div>
        <MainPage>
          <Fragment>
            <Sidebar />
            <Routes>
              <Route path='*' element={<Navigate replace to='/products' />} />
              <Route path='/products' element={<InventoryDashboard />} />
              <Route path='/modifiers' element={<Modifiers />} />
            </Routes>
          </Fragment>
        </MainPage>
      </div>
    );
  } else {
    return (
      <div>
        <Routes>
          <Route path='/login' element={<LoginOkta />} />
          <Route path='/login/callback' element={<LoginCallback />} />
          <Route path='/login/token/:token' element={<TokenLogin />} />
          <Route path='*' element={<Navigate replace to='/login' />} />
        </Routes>
      </div>
    );
  }
}
